import { shopIDsI } from "./EditProductDef.d";
import { getAllStatus } from "./getAllStatus";

const groupListedStatusType = (status: string) => {
    return getAllStatus[status].value;
}

const getHigherStatus = (parentStatus: string, childStatus: string) => {
    let priorityStatus: any = {
        "Not Listed: Offer": 0,
        "Not Listed": 1,
        "Listed": 2,
        "Error": 3
    }
    let status = "";
    if (parentStatus == "") {
        return childStatus;
    } else {
        status = priorityStatus[groupListedStatusType(childStatus)] > priorityStatus[groupListedStatusType(parentStatus)] ? childStatus : parentStatus;
    }
    return status;
}

const simpleTypeProductStatus = (marketPlaceDetails: any[], shopIDs: shopIDsI) => {
    let status = 'Not Listed';
    let targetStatus = '';
    let sourceStatus = '';
    marketPlaceDetails.forEach((ele) => {
        if (ele.shop_id == shopIDs.targetShopID) {
            targetStatus = ele?.status;
        }
    });
    status = targetStatus || status;
    return status;
}

const getMergedInfo = (marketPlaceDetails: any[]) => {
    let merged: { [name: string]: any[] } = {};
    marketPlaceDetails.forEach((ele: any) => {
        let source_product_id = ele.source_product_id;
        !merged?.[source_product_id] && (merged[source_product_id] = [])
        merged[source_product_id].push(ele);
    })
    return merged;
}

const variantTypeProductStatus = (marketPlaceDetails: any[], shopIDs: shopIDsI, product: any) => {
    let parentStatus = "";
    const mergedInfo = getMergedInfo(marketPlaceDetails);
    let someNotListed = false; let someOfferListed = false;
    Object.keys(mergedInfo).forEach((ele) => {
        if (ele !== product.source_product_id) {
            let info = mergedInfo[ele];
            let childStatus = simpleTypeProductStatus(info, shopIDs);
            childStatus == 'Not Listed' && (someNotListed = true);
            childStatus == 'Not Listed: Offer' && (someOfferListed = true);
            parentStatus = getHigherStatus(parentStatus, childStatus);
        }
    })
    let parentActualVal = groupListedStatusType(parentStatus);
    someOfferListed && !someNotListed && parentActualVal == 'Listed' && (parentStatus = 'Some Variants Listed And Some Not Listed: Offer');
    someNotListed && parentActualVal == 'Listed' && (parentStatus = 'Some Variants Listed And Some Not Listed');
    return parentStatus;
}

export const getStatusFormatted = (product: any, shopIDs: shopIDsI) => {
    let marketPlaceDetails: any[] = product?.marketplace ?? [];
    marketPlaceDetails = Object.values(marketPlaceDetails);
    let status = 'Not Listed';
    if (marketPlaceDetails[0] != null) {
        if (product.visibility == "Not Visible Individually" || product.type == 'simple') {
            status = simpleTypeProductStatus(marketPlaceDetails, shopIDs);
        } else {
            status = variantTypeProductStatus(marketPlaceDetails, shopIDs, product);
        }
    }
    return getAllStatus?.[status];
}

export const getAllErrors = (product: any, tartgetShopId: string) => {
    let errors: string[] = [];
    let marketPlaceDetails: any[] = product?.marketplace ?? [];
    marketPlaceDetails.forEach((ele) => (ele.target_marketplace === 'amazon' && ele.shop_id == tartgetShopId && (errors = ele?.errors ?? [])));
    return errors;
}

export const getEditedValue = (key: 'title' | 'sku' | 'price' | 'quantity' | 'status' | 'description', product: any, tartgetShopId: string) => {
    let val = '';
    let marketPlaceDetails: any[] = product?.marketplace ?? [];
    marketPlaceDetails.forEach((ele) => (ele.target_marketplace === 'amazon' && product.source_product_id == ele.source_product_id && ele.shop_id == tartgetShopId && (val = ele?.[key] ?? '')));
    return val ? val : product[key];
}